import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hometwo-blog',
  templateUrl: './hometwo-blog.component.html',
  styleUrls: ['./hometwo-blog.component.scss']
})
export class HometwoBlogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
